module.exports = __webpack_public_path__ + "static/media/icon_speech_bubble.e3df67cb.svg";